export default "__VITE_ASSET__Db2HHl82__"